import React from "react";

const TicketSelectHeaderActions = (props) => {
    const {setActiveScreen, isMember, memberInfo} = props;

    if (isMember && memberInfo) {
        return (
            <div className="ticket-select__header-actions">
                <span className="ticket-select__welcome-message">Welcome, {memberInfo.primaryCardHolder.firstName}</span>
                <button
                    className="ticket-select__sign-out link"
                    onClick={() => {
                        setActiveScreen("landing");
                    }}
                >
                    Sign out
                </button>
            </div>
        );
    } else {
        return "";
        /*return (
            <a className="button button--small ticket-select__become-a-member" href="/visit/membership">Become a Member</a>
        );*/
    }
}

export default TicketSelectHeaderActions;